import React, { useMemo } from 'react';
import { Form } from 'formik';
import { connect } from 'react-redux';
import Typography from '@mui/material/Typography';
import { Spacer } from '../../uikit/misc/Spacer';
import { MainLayout } from '../../components/layouts/MainLayout';
import { FormikForm } from '../../components/molecules/FormikForm';
import { SelectFormikField } from '../../components/molecules/FormFields/SelectField';
import { getTranslation } from '../../utils/translations';
import SubmitButton from '../../components/molecules/SubmitButton';
import translations from './translations';
import constants from './constants';
import { initialDataSlice } from '../../store/initialData/initialData.slice';
import helpers from './helpers';
import { miscSlice } from '../../store/misc/misc.slice';
import { MainFormLayout } from '../../components/layouts/MainFormLayout';
var t = getTranslation(translations);
var mapStateToProps = function (state) { return ({
    initialAmount: initialDataSlice.selectors.getAmount(state),
}); };
var mapDispatchToProps = function (dispatch) { return ({
    redirectToPage: function (url) {
        return dispatch(miscSlice.actions.redirectAppToPage(url));
    },
}); };
function RawSwitchingPage(_a) {
    var initialAmount = _a.initialAmount, redirectToPage = _a.redirectToPage;
    var initialValues = useMemo(function () {
        return {
            amount: helpers.getInitiallySelectedOptionValue(constants.stepsOptions, initialAmount),
        };
    }, [initialAmount]);
    return (React.createElement(MainLayout, null,
        React.createElement(MainFormLayout, null,
            React.createElement(Typography, { variant: 'h3' }, t.headerTitle),
            React.createElement(Spacer, { size: 2 }),
            React.createElement(Typography, null, t.headerSubTitle),
            React.createElement(Spacer, { size: 2 }),
            React.createElement(FormikForm, { initialValues: initialValues, onSubmit: function (values) {
                    redirectToPage(helpers.getUrlToSwitch(values.amount));
                } },
                React.createElement(Form, { noValidate: true },
                    React.createElement(SelectFormikField, { name: "amount", label: t.selectLabel, options: constants.stepsOptions }),
                    React.createElement(Spacer, { size: 1 }),
                    React.createElement(SubmitButton, { text: t.submitButtonTitle }))))));
}
export var SwitchingPage = connect(mapStateToProps, mapDispatchToProps)(RawSwitchingPage);
